const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function MicIcon({ off }: { off?: boolean }) {
  return (
    <svg viewBox="0 0 24 24" {...base} aria-hidden="true">
      <rect x="9" y="2.5" width="6" height="11" rx="3" />
      <path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" />
      {off ? <path d="M3 3l18 18" /> : null}
    </svg>
  );
}

export function CamIcon({ off }: { off?: boolean }) {
  return (
    <svg viewBox="0 0 24 24" {...base} aria-hidden="true">
      <rect x="2.5" y="6" width="13" height="12" rx="2" />
      <path d="M15.5 10.5l6-3.5v10l-6-3.5z" />
      {off ? <path d="M3 3l18 18" /> : null}
    </svg>
  );
}

export function ScreenIcon() {
  return (
    <svg viewBox="0 0 24 24" {...base} aria-hidden="true">
      <rect x="2.5" y="4" width="19" height="13" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </svg>
  );
}

export function LeaveIcon() {
  return (
    <svg viewBox="0 0 24 24" {...base} aria-hidden="true">
      <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" />
      <path d="M10 8l-4 4 4 4M6 12h9" />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg viewBox="0 0 24 24" {...base} aria-hidden="true">
      <path d="M21 12a8 8 0 0 1-8 8H4l2-3a8 8 0 1 1 15-5z" />
    </svg>
  );
}

export function CopyIcon() {
  return (
    <svg viewBox="0 0 24 24" {...base} aria-hidden="true">
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M5 15V5a2 2 0 0 1 2-2h8" />
    </svg>
  );
}

export function FullscreenIcon({ on }: { on?: boolean }) {
  return (
    <svg viewBox="0 0 24 24" {...base} aria-hidden="true">
      {on ? (
        /* Corners folded inward — the way out of fullscreen. */
        <path d="M9 3v5a1 1 0 0 1-1 1H3M16 3v5a1 1 0 0 0 1 1h5M9 21v-5a1 1 0 0 0-1-1H3M16 21v-5a1 1 0 0 1 1-1h5" />
      ) : (
        <path d="M3 9V4a1 1 0 0 1 1-1h5M15 3h5a1 1 0 0 1 1 1v5M21 15v5a1 1 0 0 1-1 1h-5M9 21H4a1 1 0 0 1-1-1v-5" />
      )}
    </svg>
  );
}

export function BlurIcon({ off }: { off?: boolean }) {
  return (
    <svg viewBox="0 0 24 24" {...base} aria-hidden="true">
      <path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z" />
      <path d="M12 3v18" />
      <path d="M15.5 5.2a9 9 0 0 1 0 13.6M18.2 8.1a9 9 0 0 1 0 7.8" />
      {off ? <path d="M3 3l18 18" /> : null}
    </svg>
  );
}
